import { Injectable } from '@angular/core';
import { PaymentData } from '../../interfaces/payment/payment-data';
import { DialogTableDataRow } from '../../interfaces/dialog-table-data-row';

@Injectable({
  providedIn: 'root'
})
export class EmailNotificationToTableDataMapper {

  constructor() { }

  public map(paymentMethodData: PaymentData): DialogTableDataRow[] {
    return [
      {
        titleColspan: true,
        i18nTitleKey: paymentMethodData.emailNotification ? 'SENDEMAILPAYMENTNOTIFICATION' : 'NOEMAILPAYMENTNOTIFICATION',
      },
      {
        titleStyleClass: 'font-bold',
        i18nTitleKey: 'EMAILADDRESS',
        value: paymentMethodData.emailAddress,
      },
    ]
  }
}
